export const projectsData = [
  {
    title: "Shooza",
    description:
      "Shooza is a TWA-type application, which is a PWA that integrates with the Google Play market without the need to be a native app and offering a mobile experience..",
    href: "https://shooza.co/",
    image: require("../../assets/projects-images/shooza-img.png"),
  },
  {
    title: "QR Restaurant Menu",
    description:
      "personal project which is an interactive restaurant menu / menu, accessed through a QR code, has no animations and is rather a simple full mobile style.",
    href: "https://lacomilona.vercel.app/",
    image: require("../../assets/projects-images/menu-qr.png"),
  },
  {
    title: "VideoGames App",
    description:
      "Development of a SPA (Single Page Application) using React for the front-end and Redux as state management. All components were developed with CSS without the use of external libraries.",
    href: "https://www.linkedin.com/posts/rodri-orozco_buenos-d%C3%ADas-reeed-tengo-el-placer-de-compartirles-activity-6916727594969141248-Ppyb?utm_source=share&utm_medium=member_desktop",
    image: require("../../assets/projects-images/games-henry.png"),
  },
  {
    title: "Weather App",
    description:
      "It is a simple application, which consumes the WeatherApp api, it is mostly developed with React, Bootstrap and JavaScript.",
    href: "https://www.linkedin.com/posts/rodri-orozco_buenaaaas-paso-a-mostrarles-la-app-del-activity-6909937228756480000-hGas?utm_source=share&utm_medium=member_desktop",
    image: require("../../assets/projects-images/weatherapp-henry.png"),
  },
  {
    title: "First Portfolio",
    description:
      "Responsive personal portfolio, where I show most of the projects I've worked on, developed with React and styled with Tailwind",
    href: "https://portafolio-ten-umber.vercel.app/",
    image: require("../../assets/projects-images/portfolio.png"),
  },
  {
    title: "StadioPlus",
    description:
      "FrontEnd project made in React for Mimusa, it has features such as Dark mode, sliders and input effects developed in Sass.",
    href: "https://stadio-plus-six.vercel.app/",
    image: require("../../assets/projects-images/stadioplus.png"),
  },
  {
    title: "Real State Web",
    description:
      "Real Estate Responsive Web Page developed with React 18, with the principle of learning position, grid and styled-components.",
    href: "https://real-estate-web-iota.vercel.app/",
    image: require("../../assets/projects-images/realstate.png"),
  },
];
